import { Box, Stack } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";
import { BasicInformationSection } from "./BasicInformationSection";
import { PaymentReceiverSection } from "./PaymentReceiverSection";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import type { Control } from "react-hook-form";
import type { CampaignFormData } from "./campaignFormSchema";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  formId: string;
  onSubmit: React.FormEventHandler;
  control: Control<CampaignFormData>;
  isSubmitting: boolean;
  isEditMode: boolean;
  campaign?: AdminCampaignDto;
  onCodeManuallyEdited: () => void;
  onNameChange: () => void;
};

export const BasicInfoStep = ({
  formId,
  onSubmit,
  control,
  isSubmitting,
  isEditMode,
  campaign,
  onCodeManuallyEdited,
  onNameChange,
}: Props) => {
  const { t } = useResource();

  return (
    <PrimaryPaper>
      <Box
        id={formId}
        component="form"
        sx={{ maxWidth: 800 }}
        onSubmit={onSubmit}
      >
        <Stack gap={4}>
          <BasicInformationSection
            control={control}
            isSubmitting={isSubmitting}
            isEditMode={isEditMode}
            onCodeManuallyEdited={onCodeManuallyEdited}
            onNameChange={onNameChange}
          />
          <PaymentReceiverSection
            control={control}
            isSubmitting={isSubmitting}
            campaign={campaign}
          />
          {!isEditMode && (
            <PrimaryButton
              fullWidth
              type="submit"
              isLoading={isSubmitting}
              variant="contained"
              color="primary"
            >
              {t(RESOURCES.CreateButton)}
            </PrimaryButton>
          )}
        </Stack>
      </Box>
    </PrimaryPaper>
  );
};
